import { SVG } from '../svg';
import { IconProps } from '../types';

export function FemaleIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props} colorTarget="fill">
      <path d="M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3.5v6h3v-6H17z"></path>
      <circle cx="12" cy="4" r="2"></circle>
    </SVG>
  );
}
